import { createContext, useContext, useEffect, useState } from "react";
import { portalApi, formatApiErrorDetail } from "@/lib/api";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const { data } = await portalApi.get("/portal/me");
    setData(data);
    return data;
  };

  useEffect(() => {
    if (!localStorage.getItem("bspark_portal_token")) {
      setLoading(false);
      return;
    }
    refresh()
      .catch(() => localStorage.removeItem("bspark_portal_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (matricula, password) => {
    try {
      const res = await portalApi.post("/portal/login", { matricula, password });
      localStorage.setItem("bspark_portal_token", res.data.access_token);
      await refresh();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (payload) => {
    try {
      const res = await portalApi.post("/portal/register", payload);
      localStorage.setItem("bspark_portal_token", res.data.access_token);
      await refresh();
      return { ok: true, matricula: res.data.matricula };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("bspark_portal_token");
    setData(null);
  };

  return (
    <PortalAuthContext.Provider value={{ data, loading, login, register, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthContext);
